import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "removeFile" ,'uploadWrap', 'file']
  remove(e){
    e.preventDefault()
    if (this.uploadWrapTarget) {
      this.uploadWrapTarget.classList.add('d-none')
      this.removeFileTarget.value = '1'
    }
    this.fileTarget.value = ''
  }
}
